import { useState } from 'react';

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

export function useGalleryBase64() {
  const [galleryObject, setGalleryObject] = useState({});

  async function prevProcessImage(url) {
    if (!url?.startsWith?.('blob:')) {
      const resImg = await fetch(url)
        .then((value) => value.blob())
        .then((value) => blobToBase64(value));
      setGalleryObject((prevState) => ({
        ...prevState,
        [url]: resImg,
      }));
    } else {
      setGalleryObject((prevState) => ({
        ...prevState,
        [url]: url,
      }));
    }
  }

  return { galleryObject, prevProcessImage };
}

export default useGalleryBase64;
